import React from 'react';
import moment from "moment";

import Currency from '../Currency';

import { getSystemSettings, getSessionId } from '../../utils/SettingsRetriever';
import { getDepositSchedule as globalGetDepositSchedule } from '../../services/cart';

import './index.scss';
import LocaleAsString from '../../LocaleEngine/LocaleAsString';

// deposit_schedule: due_now, full

export default class TotalDueNow extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            due: [],
            loading: true,
            schedule_mode: false,
            applyBorder: props.applyBorder
        }

        if(getSystemSettings().app.deposit_schedule){
            this.state.schedule_mode = getSystemSettings().app.deposit_schedule;
        }
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps){
        if(prevProps.base !== this.props.base){
            this.init();
        }
    }

    init = () => {
        if (getSessionId() !== false){
            globalGetDepositSchedule({})
            .then( (result) => {
                let dueValues = [];
                if (result.length) {
                    result.forEach(item => {
                        if (item.DueNow === 1) {
                            const alreadyFoundDueNow = dueValues.find(dueValue => dueValue.type === "dueNow")
                            if (!alreadyFoundDueNow) {
                                dueValues.push({
                                    type: "dueNow",
                                    value: item.AmountDue
                                })
                            } else {
                                dueValues[dueValues.indexOf(alreadyFoundDueNow)].value += item.AmountDue;
                            }
                        } else if (this.state.schedule_mode !== 'due_now') {
                            const alreadyFoundDueDate = dueValues.find(dueValue => dueValue.date === item.DateDue);
                            if (!alreadyFoundDueDate) {
                                dueValues.push({
                                    type: "dueOnDate",
                                    date: item.DateDue,
                                    value: item.AmountDue
                                })
                            } else {
                                dueValues[dueValues.indexOf(alreadyFoundDueDate)].value += item.AmountDue;
                            }
                        }
                    })
                }

                this.setState({...this.state, loading: false, due: dueValues});
            })
        }
        
    }

    render(){
        if(this.state.loading || !getSessionId()) return null;

        return (
            <div className="totalDueNow">
                {this.state.due.map((due, index) => {
                    return (
                        <div className={"wrapDeposit" + (this.state.applyBorder ? ' border' : '')} key={`due_${index}`}>
                             <div className="label">
                                {due.type === "dueNow" ? LocaleAsString("cart.labels.total_due_now") : `${LocaleAsString("cart.labels.total_due_on")} ${moment(due.date).format("MMM D, YYYY")}`}:
                            </div>
                            <div className="dueprice">
                                <Currency float={true} currency='usd' value={due.value}/>
                            </div>
                        </div>
                    )
                } )}
            </div>
        )
    }
}